'use client'

// No-op component that doesn't require external dependencies
export function AnalyticsProvider() {
  // Removed dependency on @vercel/analytics/next
  return null
} 